module.exports = __webpack_public_path__ + "static/media/email.48aae6c5.svg";